import { useNavigate } from 'react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAtom } from 'jotai'
import { messageAtom, spinnerAtom } from 'store/commonAtoms'
import { message } from 'config/message'


const useMyMutation = ({ mutationFn, onSettledFn, queryKey, to }) => {
    const [, setSpinner] = useAtom(spinnerAtom)
    const [, setMessage] = useAtom(messageAtom)
    const queryClient = useQueryClient()
    const navi = useNavigate()

    const msg = {}

    return useMutation({
        mutationFn : mutationFn,
        onMutate : () => {
            setSpinner(true)
        },
        onSuccess : (ret) => {
            console.log(`success ${JSON.stringify(ret, null, 4)}`)
            queryClient.invalidateQueries({ queryKey : queryKey })

            // エラーハンドリング
            if (ret.hasOwnProperty('error')) {
                msg.type = 'error'
                if (ret.error.name === 'KintoneRestAPIError') { 
                    msg.text = message[ret.error.code] || message.ERR_REGISTRATION_FAILED
                } else {
                    msg.text = message.ERR_REGISTRATION_FAILED
                }
            } else {
                msg.type = /^ERR/.test(ret.result) ? 'error' : 'info'
                msg.text = message[ret.result]
            }
        },
        onError : (error, data, context) => {
            msg.type = 'error'
            msg.text = message.ERR_REGISTRATION_FAILED
            console.log(`error ${error} ${data} ${context}`)
        },
        onSettled : (ret) => {
            setSpinner(false) 
            if (Object.keys(msg).length) { 
                setMessage(msg)
            }
            if (onSettledFn) {
                onSettledFn(ret)
            } else if (!ret.hasOwnProperty('error') && to) {
                navi(to)
            }
        },
        retry : 2,
    })
}

export default useMyMutation
